import React from "react";
import { Input } from "antd";
import { SearchOutlined } from '@ant-design/icons';
const { Search } = Input;


const CustomSearch = ({ onSearch }) => {


  const handleSearch = (value, event) => {
    event.preventDefault(); // Prevent the default behavior of the search event
    onSearch(value);
  };

  return (

    <Search
      placeholder="Search..."
      onSearch={handleSearch}
      enterButton={< SearchOutlined  className="text-xl mb-1"/>}
      allowClear
      />
  );
};

export default CustomSearch;

